module.exports = "/images/avalanche@3x.png?f4f16d4bda07875f9267a34ffe9467fe";